<div class="dialog-container dialog-generic" 
  role="dialog"
  aria-describedby="dialog-title dialog-content"
  aria-modal="true">
  @if(data.type === 'error'){
    <img id="error-icon" alt="" src="/assets/images/error.svg">
  }
  @else if(data.type === 'alert'){
    <img id="alert-icon" alt="" src="/assets/images/alert.svg">
  }
  @else if(data.type === 'ok'){
    <img id="ok-icon" alt="" src="/assets/images/logo.svg">
  } @else {
    <img id="success-icon" alt="" src="/assets/images/icon_success.svg">
  }
  <h1 id="dialog-title" mat-dialog-title aria-live="polite">{{ data.title }}</h1>
  <mat-dialog-content id="dialog-content" role="document">
    <div [innerHTML]="data.content" aria-live="polite"></div>
  </mat-dialog-content>
  <div class="dialog-button-container dialog-button-container-generic">
    <button i18n cdkFocusInitial class="button-primary" mat-dialog-close aria-label="OK. Close pop-up." i18n-aria-label >OK</button>
  </div>
</div>